<section
  [ngStyle]="{
    'background-image':
      'url(' + staticImagesUrl + 'assets/images/demo/homepage/find-yourself-banner-charitybooster.jpg)'
  }"
  class="quote-block py-7"
>
  <div class="container h-100">
    <div class="row justify-content-center align-items-center h-100">
      <div class="col-12 col-lg-9 text-center">
        <blockquote class="py-4 px-5 bg-primary text-white m-0">
          <p class="h3 text-white mb-3">
            “The best way to find yourself is to lose yourself in the service of others.”
          </p>
          <p class="m-0 fs-lg">MAHATMA GANDHI</p>
        </blockquote>
      </div>
    </div>
  </div>
</section>
